/* eslint-disable import/no-cycle */
import api from '../helpers/api';

const API_URL = '/connection-whitelist';

async function getIps(institutionId) {
  try {
    const response = await api.get(`${API_URL}/${institutionId}`);
    return response.split(',') || [''];
  } catch (error) {
    console.error('Erro ao buscar os IPs:', error);
    throw error;
  }
}

async function saveOrUpdateIps(institutionId, ipString = '') {
  try {
    const response = await api.put(`${API_URL}/${institutionId}`, { ips: ipString });
    return response.status; // <-- Retorna status para controle
  } catch (error) {
    console.error('Erro ao salvar os IPs:', error);
    throw error;
  }
}

export const configureIpsService = { getIps, saveOrUpdateIps };
